<script setup>
/* Imports */
import {
  ref,
  inject,
} from 'vue';
import router from '../router/router.js';

/* Inject */
const translations = inject('translations');
const showGarminMaps = inject('showGarminMaps');
const submitSearch = inject('submitSearch');

const buttons = ref([
  {
    id: 'garmin',
    content: 'Garmin',
    onClick: (e, button) => {
      // eslint-disable-next-line no-use-before-define
      handleButtonSelection(button);
    },
    selected: showGarminMaps.value,
  },
  {
    id: 'another-brand',
    content: translations.value.ITFE_MARINE_MAPS_ANOTHER_BRAND,
    onClick: (e, button) => {
      // eslint-disable-next-line no-use-before-define
      handleButtonSelection(button);
    },
    selected: !showGarminMaps.value,
  },
]);

const handleButtonSelection = (clickedButton) => {
  // update maps query param with new product filter selection
  const existingQueryParams = Object.fromEntries(new URLSearchParams(window?.location?.search));
  // router.push is needed for back button functionality
  router.push({
    query: { ...existingQueryParams, maps: clickedButton.id },
  });
};

const buttoGroupDataTestId = {
  host: 'product-filter__button-group',
  buttons: [
    'product-filter__button-group__garmin-button',
    'product-filter__button-group__another-brand-button',
  ],
};
</script>

<template>
  <div
    class="product-filter"
    data-testid="product-filter"
  >
    <g-button-group
      class="product-filter__button-group"
      :label="translations.ITFE_MARINE_MAPS_PRODUCT_FILTER"
      .buttons="buttons"
      data-testid="product-filter__button-group"
      :dataTestId.prop="buttoGroupDataTestId"
      @click="submitSearch"
    />
  </div>
</template>

<style lang="scss">
.product-filter {
  margin-bottom: 1rem;

  &__button-group {
    display: flex;
    margin-bottom: 1rem;

    button {
      width: 50%;
      padding: 0.875rem;
    }
  }
}
</style>
